export default __webpack_public_path__ + "b8155302e70eddfba794240e4d51d497.jpg";